import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import memoizeOne from '../../node_modules/memoize-one/dist/memoize-one.esm.js';
import { omitProps, countErrors } from './utils.js';
import FormContext$1 from './FormContext.js';

var getDefaultOptions = function getDefaultOptions() {
  return {
    defaultProps: {}
  };
};

var withForm = function withForm() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultOptions();
  return function (FormComponent) {
    var _class, _temp;

    var defaultOptions = getDefaultOptions();
    var formDefaultProps = options.defaultProps || defaultOptions.defaultProps;
    return _temp = _class = /*#__PURE__*/function (_React$Component) {
      _inherits(FormWrapper, _React$Component);

      var _super = _createSuper(FormWrapper);

      function FormWrapper() {
        var _this;

        _classCallCheck(this, FormWrapper);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this), "state", {
          errors: {}
        });

        _defineProperty(_assertThisInitialized(_this), "_prevChangeMetadata", undefined);

        _defineProperty(_assertThisInitialized(_this), "_prevChangeValue", undefined);

        _defineProperty(_assertThisInitialized(_this), "_prevValid", undefined);

        _defineProperty(_assertThisInitialized(_this), "defaultOnError", function (field, errors, applyErrors) {
          var onStateUpdated = function onStateUpdated() {
            if (!_this.props.onValidated) return;
            var totalErrors = countErrors(_this.state.errors);
            var valid = totalErrors === 0;

            if (valid !== _this._prevValid) {
              _this._prevValid = valid;

              _this.props.onValidated(valid);
            }
          };

          _this.setState(function (state) {
            var newErrors = applyErrors(state.errors);

            if (newErrors === state.errors) {
              return null;
            }

            return {
              errors: newErrors
            };
          }, onStateUpdated);
        });

        _defineProperty(_assertThisInitialized(_this), "getFormContext", memoizeOne(function (value, onChange, errors, onError, showErrors, allErrors, animateErrors, disabled, readOnly, previousChange) {
          return {
            value: value,
            onChange: onChange,
            errors: errors,
            onError: onError,
            showErrors: showErrors,
            allErrors: allErrors,
            animateErrors: animateErrors,
            disabled: disabled,
            readOnly: readOnly,
            previousChange: previousChange
          };
        }));

        _defineProperty(_assertThisInitialized(_this), "onChange", function (field, data, applyChanges, metadata) {
          // keep track of the previous change state
          _this._prevChangeMetadata = metadata;
          _this._prevChangeValue = _this.props.value;

          _this.props.onChange(field, data, applyChanges, metadata);
        });

        return _this;
      }

      _createClass(FormWrapper, [{
        key: "render",
        value: function render() {
          var _ref = this.props,
              value = _ref.value,
              errors = _ref.errors,
              onError = _ref.onError,
              _ref$showErrors = _ref.showErrors,
              showErrors = _ref$showErrors === void 0 ? false : _ref$showErrors,
              _ref$allErrors = _ref.allErrors,
              allErrors = _ref$allErrors === void 0 ? false : _ref$allErrors,
              _ref$animateErrors = _ref.animateErrors,
              animateErrors = _ref$animateErrors === void 0 ? false : _ref$animateErrors,
              _ref$disabled = _ref.disabled,
              disabled = _ref$disabled === void 0 ? false : _ref$disabled,
              _ref$readOnly = _ref.readOnly,
              readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
              children = _ref.children;
          var passThruProps = omitProps(this.props, Object.keys(FormWrapper.propTypes)); // determine if the form value corresponds with the metadata of the previous change

          var previousChange = this._prevChangeValue === this.state.prevValue ? this._prevChangeMetadata : undefined;
          var formContext = this.getFormContext(value, this.onChange, errors !== null && errors !== void 0 ? errors : this.state.errors, onError !== null && onError !== void 0 ? onError : this.defaultOnError, showErrors, allErrors, animateErrors, disabled, readOnly, previousChange);
          return /*#__PURE__*/React.createElement(FormComponent, _extends({}, this.props, {
            onChange: this.onChange,
            errors: errors || this.state.errors,
            onErrors: onError || this.defaultOnError,
            passThruProps: passThruProps
          }), /*#__PURE__*/React.createElement(FormContext$1.Provider, {
            value: formContext
          }, typeof children === "function" ? children(value, errors || this.state.errors) : children));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(props, state) {
          // keep track of the previous form value
          if (props.value !== state.value) {
            return {
              value: props.value,
              prevValue: state.value
            };
          }

          return null;
        }
      }]);

      return FormWrapper;
    }(React.Component), _defineProperty(_class, "propTypes", {}), _defineProperty(_class, "defaultProps", _objectSpread2({
      value: {},
      onChange: function onChange() {},
      showErrors: false,
      allErrors: false,
      animateErrors: false,
      disabled: false,
      readOnly: false
    }, formDefaultProps)), _defineProperty(_class, "displayName", "withForm(".concat(FormComponent.displayName || FormComponent.name, ")")), _temp;
  };
};

var withForm$1 = withForm;

export { withForm$1 as default };
